import { Link } from "react-router-dom";
import { Logo } from "./Logo";
import { scrollToId } from "@/lib/api";
import { useSettings } from "@/lib/settings";

export const Footer = () => {
  const { settings: s } = useSettings();
  return (
  <footer className="tone-dark relative overflow-hidden bg-[var(--ink)] pt-20">
    <div className="mx-auto grid max-w-7xl gap-10 px-5 sm:px-8 md:grid-cols-4">
      <div className="md:col-span-2">
        <Logo />
        <p className="mt-4 max-w-xs text-sm text-mist">Smartphone, audio e accessori. Acquisto online, permuta e riparazioni.</p>
      </div>
      <div className="space-y-2 text-sm">
        <p className="font-mono-ui text-xs uppercase tracking-widest text-mist">Naviga</p>
        <button onClick={() => scrollToId("catalogo")} data-testid="footer-catalog-link" className="block text-fg2 hover:text-fg">Catalogo</button>
        <button onClick={() => scrollToId("servizi")} data-testid="footer-services-link" className="block text-fg2 hover:text-fg">Servizi</button>
        <button onClick={() => scrollToId("richiesta")} data-testid="footer-request-link" className="block text-fg2 hover:text-fg">Contatti</button>
        <Link to="/admin" data-testid="footer-admin-link" className="block text-fg2 hover:text-fg">Area riservata</Link>
      </div>
      <div className="space-y-2 text-sm text-fg2" data-testid="footer-contacts">
        <p className="font-mono-ui text-xs uppercase tracking-widest text-mist">Negozio</p>
        {s.shop_address && <p>{s.shop_address}</p>}
        {s.shop_phone && <a href={`tel:${s.shop_phone.replace(/\s/g, "")}`} className="block hover:text-fg">{s.shop_phone}</a>}
        {s.shop_email && <a href={`mailto:${s.shop_email}`} className="block hover:text-fg">{s.shop_email}</a>}
        {s.shop_vat && <p>{s.shop_vat}</p>}
      </div>
    </div>
    <p aria-hidden className="mt-16 select-none whitespace-nowrap text-center font-display text-[13.5vw] font-bold leading-[0.8] tracking-tighter text-outline">PhoneSmartX</p>
    <p className="absolute bottom-4 left-0 right-0 text-center text-xs text-mist">© 2026 PhoneSmartX. Tutti i diritti riservati.</p>
  </footer>
  );
};
